const UPDATE_ITEM_TIMEOUT = 400;

export const updateValueService = {
    updateValueTimeout: null,
    updateItemValue(saveItemFunction) {
        if(this.updateValueTimeout) {
            clearTimeout(this.updateValueTimeout);
            this.updateValueTimeout = null;
        }
        this.updateValueTimeout = setTimeout(() => {
            saveItemFunction();
            clearTimeout(this.updateValueTimeout);
        }, UPDATE_ITEM_TIMEOUT);
    },
};
